/* eslint-disable import/no-cycle */
import React, { useState } from "react";

import { format as formatDate } from "date-fns/fp";

import { withTrackPage } from "analytics";

import { IntegrationProps } from "./types";
import { MICRODEPOSIT } from "../consts";
import TrustlyIntegrationMain from "./TrustlyIntegrationMain";
/* eslint-enable import/no-cycle */

export const getCurrentUTCDate = () => {
  const date = new Date();

  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
};

export const dateFormat = formatDate("yyyy-MM-dd HH:mm:ss");

const IAVProviderIntegration = ({
  accountId,
  type,
  ...props
}: IntegrationProps) => {
  const [startAt] = useState(dateFormat(getCurrentUTCDate()));
  const requestType = accountId ? MICRODEPOSIT : type;

  return (
    <TrustlyIntegrationMain
      {...props}
      type={type}
      requestType={requestType}
      startAt={startAt}
    />
  );
};

export default withTrackPage(IAVProviderIntegration);
